import React, { forwardRef } from 'react';

import cx from 'classnames';

import { Text } from 'components/Text';

import styles from './input.module.scss';

interface TextareaProps {
  ref?: React.Ref<HTMLTextAreaElement>;
  placeholder?: string;
  rows?: number;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  viewOnly?: boolean;
  autoFocus?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
}

const TextAreaGrabberIcon = React.memo(() => {
  return (
    <svg className={styles.textareaGrabber} fill="none" viewBox="0 0 16 16">
      <path d="M9.5 13.5L14.5 8.5" />
      <path d="M12.5 13.5L14.5 11.5" />
      <path d="M6.5 13.5L14.5 5.5" />
    </svg>
  );
});

export const TextareaRef = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ rows = 4, value, viewOnly, ...props }, ref) => {
    return (
      <div className={styles.container}>
        <textarea
          ref={ref}
          className={cx(styles.input, styles.textarea)}
          disabled={viewOnly}
          rows={rows}
          {...props}
          {...(value && { value })}
        />
        <TextAreaGrabberIcon />
      </div>
    );
  },
);

export interface TextareaNoRefProps {
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  viewOnly?: boolean;
  rows?: number;
  value?: string;
  maxSymbols?: number;
  onChange?: (text: string) => void;
}

export const TextareaNoRef: React.FC<TextareaNoRefProps> = ({
  placeholder,
  disabled = false,
  viewOnly = false,
  autoFocus,
  rows = 4,
  value = '',
  maxSymbols = 1000,
  onChange = () => null,
}) => (
  <div className={styles.textareaContainer}>
    <textarea
      autoFocus={autoFocus}
      className={cx(styles.input, styles.textarea, { [styles.viewOnly]: viewOnly })}
      disabled={viewOnly || disabled}
      placeholder={placeholder}
      rows={rows}
      value={value}
      maxLength={maxSymbols}
      onChange={event => onChange(event.target.value)}
    />
    <Text.CapsS className={styles.maxSymbols}>
      {value.length} / {maxSymbols}
    </Text.CapsS>
  </div>
);
